export default "__VITE_ASSET__BRn2L4Rk__"